<template >
    <div class="h-100">
        <div>
            <div class="h-100 d-flex justify-content-center pt-5 container-fluid">
                <div class="card login-container">
                    <div class="p-5 text-center text-muted">
                        <img src="/images/goodeats-logo.png" class="login-container-logo">
                        <form @submit.prevent="submitLogin" class="pt-5">
                            <div class="form-group">
                                <input type="text" placeholder="Store name" class="form-control" v-model="login_form.subdomain" required>
                            </div>
                            <div class="form-group pt-1">
                                <input placeholder = "Username" type="text" class="form-control" v-model="login_form.username" required>
                            </div>
                            <div class="form-group pt-1">
                                <input :type="(show_password ? 'text' : 'password')" placeholder="Password" class="form-control" v-model="login_form.password" required>
                            </div>
                            <div class="custom-control custom-checkbox showpassword pt-3 pb-3">
                                <input type="checkbox" class="custom-control-input" id="defaultUnchecked" v-model="show_password">
                                <label class="custom-control-label text-muted" for="defaultUnchecked">Show password</label>
                            </div>
                            <button
                                type="submit" class="btn text-center mt-3 btn-block btn-dark-bg">
                                Login <icon class="ml-3" name="arrow-right"></icon>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- select register modal -->
        <div v-if="show_settings_modal">
            <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-body text-center">
                        <img v-if="settings.client_config.client_logo" :src="settings.client_config.client_logo" class="rounded mx-auto d-block pt-3 outlet-img" :alt="settings.client_config.subdomain">
                        <p v-else class="font-weight-bold">{{settings.client_config.subdomain}}</p>
                        <div class="form-group pt-4">
                            <label for="register-select" class="pb-3">Select register</label>
                            <select class="form-control" id="register-select" v-model="selected_register">
                                   <option :key="register.id" v-for="register in registers" :value="register">
                                        {{ register.register_name }}
                                   </option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary-outline btn-close" @click="show_settings_modal = false">Cancel</button>
                        <button type="button" class="btn btn-dark-bg" @click="selectRegister">Proceed</button>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </transition>
        </div>
        <!-- end -->
        <!-- staff modal -->
        <div v-if="show_staff_modal">
            <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-body text-center">
                        <img v-if="settings.client_config.client_logo" :src="settings.client_config.client_logo"
                            class="rounded mx-auto d-block pt-3 outlet-img" :alt="settings.client_config.subdomain"
                        >
                        <p v-else class="font-weight-bold">{{settings.client_config.subdomain}}</p>
                        <form @submit.prevent="completeLogin">
                            <div class="form-group pt-4">
                                <label for="passcode" class="pb-3">Enter Staff PIN</label>
                                <input id="passcode" type="password" inputmode="numeric" placeholder="PIN e.g. 1234" class="form-control" v-model="staff_passcode" required>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary-outline btn-close" @click="goBack">Back</button>
                        <button type="button" class="btn btn-dark-bg" @click="completeLogin" :disabled="!staff_passcode">Proceed</button>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </transition>
        </div>
        <!-- end -->
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        data() {
            return {
                app: this.$root.$data.app,
                show_password: false,
                show_settings_modal: false,
                show_staff_modal: false,
                login_form: {
                    subdomain: '',
                    username: '',
                    password: '',
                },
                settings: [],
                selected_register: {},
                staff_passcode: null,
                registers: [],
            }
        },

        mounted(){
            this.setLoading(false)
            if(this.user)
                this.$router.replace({name: 'home'})
        },

        methods: {
            ...mapMutations([
                'setToken',
                'setLoading',
                'configSession',
                'logout',
                'setSearchSetting',
                'setSoundSetting',
                'setCollectionPoints',
                'setIgnoreCollectionPoints',
            ]),

            submitLogin(){
                this.setLoading(true)
                this.app.http.post('login', this.login_form)
                    .then(response => {
                        this.login_user = response.data.config.user_config
                        this.setToken(response.data.token)
                        this.app.http.get('settings')
                            .then(response => {
                                this.settings = response.data.data
                                this.registers = this.settings.registers.data.filter((register)=>{
                                    return JSON.parse(register.print_settings).show_web_module == 1
                                })
                                this.selected_register = this.registers[0]
                                this.show_settings_modal = true
                            })
                            .catch(error => {
                                Swal.fire({
                                    icon: 'error',
                                    text: error.response.data.error,
                                })
                            })
                    })
                    .catch(error => {
                        this.setLoading(false)
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.error,
                        })
                    })
            },

            selectRegister(){
                this.show_settings_modal = false
                this.show_staff_modal = true
            },

            goBack(){
                this.show_staff_modal = false
                this.show_settings_modal =  true
            },

            completeLogin() {
                const staff  = this.settings.staffs.data.find(staff => staff.passcode == this.staff_passcode)
                if (!staff){
                        Swal.fire({
                        icon: 'error',
                        title: "Incorrect PIN",
                        text: "Please try again"
                    })
                    return
                }
                this.show_staff_modal = false
                this.configSession({
                    user: this.login_user,
                    register_id: this.selected_register.id,
                    staff_id: staff.id,
                    client: {
                        id: this.settings.client_config.subdomain,
                        name: this.settings.client_config.client_name
                    },
                    outlet: {
                        id: this.settings.outlet_config.id,
                        name: this.settings.outlet_config.outlet_name
                    },
                    logo: this.settings.client_config.client_logo,
                    currency: this.settings.client_config.default_currency_symbol,
                    install_id: this.install_id,
                    partner_source: this.settings.client_config.partner_source,
                    colour_theme: this.settings.colour_theme,
                })
                this.setSearchSetting(true)
                this.setSoundSetting(true)
                this.setCollectionPoints([])
                this.setIgnoreCollectionPoints(true)

                this.login_form.password = ""
            },
        },

        computed: {
            ...mapGetters([
                'user',
                'outlet',
                'logo',
            ]),

        },
    }
</script>

<style scoped>
    #loading-mask .modal-dialog {
        width: 200px;
    }

    #loading-mask {
        z-index: 9998;
    }

    .outlet-img {
        max-width: 100px;
    }

    .login-container {
        width: 350px;
    }

    .login-container-logo {
        height: 40px;
        width: auto;
    }

    .btn-status {
        width: 130px;
    }

    .btn-close {
        box-shadow: none !important;
        padding-right: 10px;
    }

    .showpassword {
        font-size: 14px;
    }
</style>